// https://web-crunch.com/posts/how-to-create-accordion-vanilla-javascript

import config from '../config';
import { setSectionNumber } from "./section-indicators";

export function scene4ScrollTriggers(){
  const deviceContainer: HTMLElement = document.getElementById(
    "scene-4-device-canvas-container"
  );
  const video: HTMLVideoElement = document.getElementById(
    "scene-4-device-screen-video"
  ) as HTMLVideoElement;

  const tlIntro = gsap.timeline({
    scrollTrigger: {
      id: `scene-4-fade-in`,
      trigger: `#scene-4-start`,
      start: "top bottom-=20",
      end: `top center+=${config.pinTextOffset}`,
      pin: false,
      // markers: true,
      onEnter: function () {
        setSectionNumber(4);
        try {
          video.play();
        } catch (e) {
          console.error("error playing section 4 video", e);
        }
      },
      onLeaveBack: function () {
        try {
          video.pause();
        } catch (e) {
          console.error("error pausing section 4 video", e);
        }
      },
    },
  });
  tlIntro.addLabel("start");
  tlIntro.to(
    "#PageContainer",
    {
      background: "#fff",
      duration: 1,
    },
    "start"
  );
  tlIntro.from(
    "#scene-4",
    {
      duration: 1,
      autoAlpha: 0,
    },
    "start"
  );

  const tlLock = gsap.timeline({
    scrollTrigger: {
      id: `scene-4-lock`,
      trigger: `#scene-4`,
      start: function () {
        if (config.mobileLayout) {
          return "top top+=70";
        }
        return "top top+=94";
      },
      end: `+=${config.scrollSpan / 2}`,
      pin: true,
      pinSpacing: true,
      // markers: true,
    },
  });
}

export default function () {
  const deviceContainer: HTMLElement = document.getElementById('scene-4-device-canvas-container');
  const video: HTMLVideoElement = document.getElementById('scene-4-device-screen-video') as HTMLVideoElement;
  const accordionItems = document.querySelectorAll("#scene-4 .accordion-item");

  const mobileFullScreenContainer: HTMLElement = document.getElementById(
    "scene-4-device-canvas-container-mobile"
  );
  const mobileFullScreenCanvas: HTMLElement = document.querySelector(
    "#scene-4-device-canvas-container-mobile .scene-4-device-canvas-container"
  );
  const mobileVideo: HTMLVideoElement = document.querySelector(
    "#scene-4-device-canvas-container-mobile .scene-4-device-screen-video"
  ) as HTMLVideoElement;
  const mobileFullScreenTitle: HTMLElement = document.querySelector(
    "#scene-4-device-canvas-container-mobile .accordion-title"
  );
  const mobileFullScreenDesc: HTMLElement = document.querySelector(
    "#scene-4-device-canvas-container-mobile .accordion-desc"
  );
  const closeButton: HTMLElement = document.querySelector(
    "#scene-4-device-canvas-container-mobile .landing-icon"
  ) as HTMLElement;

  accordionItems.forEach(function (item) {
    item.addEventListener("click", toggleAccordion);
  });

  mobileFullScreenContainer.addEventListener("click", function () {
    console.log("mobilePlayer clicked");
    hideMobileVideo();
  });
  let original = {
    top: 0,
    left: 0,
    width: 0,
    height: 0,
  };
  function showMobileVideo(){
    const boundingRect = deviceContainer.getBoundingClientRect();
    const { top, left, width, height } = boundingRect;
    original = {
      top,
      left,
      width,
      height,
    };

    const tl = gsap.timeline();
    tl.addLabel('start');
    tl.set(
      deviceContainer,
      {
        visibility: 'hidden'
      },
      "start"
    );
    tl.set(mobileFullScreenContainer, {
      display: "block",
    }, 'start');
    tl.set(
      mobileFullScreenCanvas,
      {
        top: top + height / 2, // Compensate for canvas's transform: -50%
        left: left + width / 2, // Compensate for canvas's transform: -50%
        width,
        height,
        display: "block",
      },
      "start"
    );
    tl.to(
      mobileFullScreenCanvas,
      {
        duration: 0.8,
        top: "45%",
        left: "50%",
        height: "150vw",
        width: "150vw",
      },
      "start"
    );
    tl.to(
      mobileFullScreenContainer,
      {
        duration: 0.8,
        backgroundColor: "rgba(255,255,255,1)",
      },
      "start"
    );
    tl.fromTo(
      [closeButton, mobileFullScreenTitle, mobileFullScreenDesc],
      {
        autoAlpha: 0,
      },
      {
        duration: 0.25,
        autoAlpha: 1,
      },
      "start+=.65"
    );
  }
  function hideMobileVideo(){
    const boundingRect = deviceContainer.getBoundingClientRect();
    const { top, left, width, height } = boundingRect;
    original = {
      top,
      left,
      width,
      height,
    };
    const tl = gsap.timeline({
      onComplete: function () {
        gsap.set(
          deviceContainer,
          {
            visibility: "visible",
          }
        );
        gsap.set(mobileFullScreenContainer, {
          display: "none",
        });
      },
    });
    tl.addLabel("start");
    tl.to(
      mobileFullScreenContainer,
      {
        duration: 0.8,
        backgroundColor: "rgba(255,255,255,0)",
      },
      "start+=.1"
    );
    tl.to(
      mobileFullScreenCanvas,
      {
        duration: 0.8,
        top: top + height / 2, // Compensate for canvas's transform: -50%
        left: left + width / 2, // Compensate for canvas's transform: -50%
        height,
        width,
      },
      "start+=.1"
    );
    tl.to(
      [closeButton, mobileFullScreenTitle, mobileFullScreenDesc],
      {
        duration: 0.25,
        autoAlpha: 0,
      },
      "start"
    );
  }

  function toggleAccordion(e) {
    accordionItems.forEach(function (item: HTMLElement) {
      if (item === e.currentTarget) {
        if (item.classList.contains("active")) {
          return;
        }
        item.classList.add("active");
        gsap.set(item.querySelector(".accordion-desc"), { height: "auto" });
        gsap.from(item.querySelector(".accordion-desc"), 0.3, { height: 0 });

        const videoSrc = item.dataset.videoSrc;
        console.log('change video src', videoSrc);
        video.src = videoSrc;
        video.play();

        if (config.mobileLayout){
          mobileVideo.src = videoSrc;
          mobileVideo.play();
          mobileFullScreenTitle.innerHTML = item.querySelector(".accordion-title").innerHTML;
          mobileFullScreenDesc.innerHTML = item.querySelector(".accordion-desc").innerHTML;
          showMobileVideo();
        }
      } else {
        item.classList.remove("active");
        gsap.to(item.querySelector(".accordion-desc"), 0.3, { height: 0 });
      }
    });
  }
}